module.exports = __webpack_public_path__ + "assets/img/K8.32b6139f.png";